const styleSheet = (theme: any) => ({
  header: {
    color: "#6373A4",
    fontSize: "12px",
    marginBottom: "-6px"
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Table/TableHeader/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/hoc/Table/TableHeader/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }